// ** React Imports
import React, { createContext, useContext, } from "react"
// ** Store & Actions
// ** Third Party Components
import { type AnySchema, } from "joi"
import {
  type FieldValues,
  type DefaultValues,
  type SubmitHandler,
  type SubmitErrorHandler,
  type UseFormRegister,
  type UseFormWatch,
  type UseFormSetValue,
  type UseFormGetValues,
  type UseFormTrigger,
  type UseFormReset,
  type UseFormResetField,
  type FieldErrorsImpl,
  type Control,
  // FieldArray,
  // FieldArrayPath,
  // FieldError,
  // FormState,
  // UseFormRegisterReturn,
  // Validate,
  // ValidationRule,
} from "react-hook-form"
// ** Custom Components
// ** Hooks, context & utils
import { useReactHookForm, } from "hooks/useReactHookForm"
// ** Conf & helpers
// ** Styles
// ** Images


interface VerticalFormContextProps<TFormValues extends FieldValues> {
  readonly register: UseFormRegister<TFormValues>
  readonly formState: {
    dirtyFields: Partial<Readonly<Record<string, any>>>
    touchedFields: Partial<Readonly<Record<string, any>>>
    defaultValues?: TFormValues
    isSubmitted: boolean
    isSubmitSuccessful: boolean
    submitCount: number
    isValid: boolean
    errors: Partial<FieldErrorsImpl<Record<string, any>>>
  }
  readonly watch: UseFormWatch<TFormValues>
  readonly reset: UseFormReset<TFormValues>
  readonly resetField: UseFormResetField<TFormValues>
  readonly setValue: UseFormSetValue<TFormValues>
  readonly getValues: UseFormGetValues<TFormValues>
  readonly trigger: UseFormTrigger<TFormValues>
  readonly control: Control<TFormValues, any>
}

const VerticalFormContext = createContext<VerticalFormContextProps<any>>({
  // register: name => ({
  //   onChange: async () => await new Promise(() => {}),
  //   onBlur: async () => await new Promise(() => {}),
  //   ref: instance => {},
  //   name,
  // }),
  // formState: {
  //   dirtyFields: {},
  //   touchedFields: {},
  //   defaultValues: {},
  //   isSubmitted: false,
  //   isSubmitSuccessful: false,
  //   submitCount: 0,
  //   isValid: true,
  //   errors: {},
  // },
  // watch: () => ([]) as any,
  // reset: () => {},
  // resetField: () => {},
  // setValue: () => {},
  // getValues: () => ([]) as any,
  // trigger: async () => true,
  // control: {
  //   _subjects: {
  //     watch: undefined,
  //     array: undefined,
  //     state: undefined
  //   },
  //   _removeUnmounted: function (): void {
  //     throw new Error("Function not implemented.")
  //   },
  //   _focusError: function (): void {
  //     throw new Error("Function not implemented.")
  //   },
  //   _names: {
  //     mount: undefined,
  //     unMount: undefined,
  //     array: undefined,
  //     watch: undefined,
  //     focus: undefined,
  //     watchAll: undefined
  //   },
  //   _stateFlags: {
  //     mount: false,
  //     action: false,
  //     watch: false
  //   },
  //   _reset: function (values?: any, keepStateOptions?: Partial<{ keepDirtyValues: boolean; keepErrors: boolean; keepDirty: boolean; keepValues: boolean; keepDefaultValues: boolean; keepIsSubmitted: boolean; keepTouched: boolean; keepIsValid: boolean; keepSubmitCount: boolean }> | undefined): void {
  //     throw new Error("Function not implemented.")
  //   },
  //   _options: undefined,
  //   _getDirty: function <TName extends string, TData>(name?: TName | undefined, data?: TData | undefined): boolean {
  //     throw new Error("Function not implemented.")
  //   },
  //   _formState: {
  //     isDirty: false,
  //     isLoading: false,
  //     isSubmitted: false,
  //     isSubmitSuccessful: false,
  //     isSubmitting: false,
  //     isValidating: false,
  //     isValid: false,
  //     submitCount: 0,
  //     defaultValues: undefined,
  //     dirtyFields: undefined,
  //     touchedFields: undefined,
  //     errors: undefined
  //   },
  //   _updateValid: function (shouldUpdateValid?: boolean | undefined): void {
  //     throw new Error("Function not implemented.")
  //   },
  //   _updateFormState: function (formState: Partial<FormState<any>>): void {
  //     throw new Error("Function not implemented.")
  //   },
  //   _fields: undefined,
  //   _formValues: undefined,
  //   _proxyFormState: undefined,
  //   _defaultValues: undefined,
  //   _getWatch: function (fieldNames?: string | string[] | undefined, defaultValue?: any, isMounted?: boolean | undefined, isGlobal?: boolean | undefined) {
  //     throw new Error("Function not implemented.")
  //   },
  //   _updateFieldArray: function <T extends Function, TFieldValues extends FieldValues, TFieldArrayName extends FieldArrayPath<TFieldValues> = FieldArrayPath<TFieldValues>>(name: string, updatedFieldArrayValues?: Partial<FieldArray<TFieldValues, TFieldArrayName>>[] | undefined, method?: T | undefined, args?: Partial<{ argA: unknown; argB: unknown }> | undefined, shouldSetValue?: boolean | undefined, shouldUpdateFieldsAndErrors?: boolean | undefined): void {
  //     throw new Error("Function not implemented.")
  //   },
  //   _getFieldArray: function <TFieldArrayValues>(name: string): Partial<TFieldArrayValues>[] {
  //     throw new Error("Function not implemented.")
  //   },
  //   _executeSchema: function (names: string[]): Promise<{ errors: Partial<FieldErrorsImpl<{ [x: string]: any }>> }> {
  //     throw new Error("Function not implemented.")
  //   },
  //   register: function <TFieldName extends string = string>(name: TFieldName, options?: Partial<{ required: string | ValidationRule<boolean>; min: ValidationRule<string | number>; max: ValidationRule<string | number>; maxLength: ValidationRule<number>; minLength: ValidationRule<number>; pattern: ValidationRule<RegExp>; validate: Validate<TFieldName extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? any : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : TFieldName extends string | number | symbol ? any : TFieldName extends `${number}` ? unknown : never, any> | Record<string, Validate<TFieldName extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? any : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : TFieldName extends string | number | symbol ? any : TFieldName extends `${number}` ? unknown : never, any>>; valueAsNumber: boolean; valueAsDate: boolean; value: TFieldName extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? R extends `${infer K}.${infer R}` ? K extends string | number | symbol ? R extends string ? any : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : R extends string | number | symbol ? any : R extends `${number}` ? unknown : never : never : K extends `${number}` ? never : never : TFieldName extends string | number | symbol ? any : TFieldName extends `${number}` ? unknown : never; setValueAs: (value: any) => any; shouldUnregister?: boolean | undefined; onChange?: ((event: any) => void) | undefined; onBlur?: ((event: any) => void) | undefined; disabled: boolean; deps: string | string[] }> | undefined): UseFormRegisterReturn<TFieldName> {
  //     throw new Error("Function not implemented.")
  //   },
  //   unregister: function (name?: string | string[] | readonly string[] | undefined, options?: (Omit<Partial<{ keepDirtyValues: boolean; keepErrors: boolean; keepDirty: boolean; keepValues: boolean; keepDefaultValues: boolean; keepIsSubmitted: boolean; keepTouched: boolean; keepIsValid: boolean; keepSubmitCount: boolean }>, "keepErrors" | "keepValues" | "keepDefaultValues" | "keepIsSubmitted" | "keepSubmitCount"> & { keepValue?: boolean | undefined; keepDefaultValue?: boolean | undefined; keepError?: boolean | undefined }) | undefined): void {
  //     throw new Error("Function not implemented.")
  //   },
  //   getFieldState: function <TFieldName extends string>(name: TFieldName, formState?: FormState<any> | undefined): { invalid: boolean; isDirty: boolean; isTouched: boolean; error?: FieldError | undefined } {
  //     throw new Error("Function not implemented.")
  //   }
  // },
} as VerticalFormContextProps<any>)

const useVerticalForm = <TFormValues extends FieldValues = FieldValues>(): VerticalFormContextProps<TFormValues> => useContext(VerticalFormContext)

interface VerticalFormProviderProps<TFormValues extends FieldValues> {
  id: string
  schema: AnySchema
  context?: object
  initialValues: DefaultValues<TFormValues>
  onSubmit: SubmitHandler<TFormValues>
  onError?: SubmitErrorHandler<TFormValues>
  formClass?: string
  children?: React.ReactNode
}

const VerticalFormProvider = <TFormValues extends FieldValues = FieldValues>(props: VerticalFormProviderProps<TFormValues>): JSX.Element => {
  const {
    id,
    schema,
    context,
    initialValues,
    onSubmit,
    onError,
    formClass,
    children,
  } = props

  const {
    register,
    // unregister,
    formState,
    watch,
    handleSubmit,
    reset,
    resetField,
    // setError,
    // clearErrors,
    setValue,
    // setValues,
    // setFocus,
    getValues,
    // getFieldState,
    trigger,
    control,
  } = useReactHookForm<TFormValues>(
    schema,
    context ?? {},
    initialValues,
    onSubmit,
    onError
  )

  return (
    <VerticalFormContext.Provider value={{
      register,
      formState,
      watch,
      reset,
      resetField,
      setValue,
      getValues,
      trigger,
      control,
    }}>
      {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
      <form id={id} onSubmit={handleSubmit} className={formClass} noValidate>
        {Array.isArray(children)
          ? children.map(child => child)
          : children}
      </form>
    </VerticalFormContext.Provider>
  )
}

export { useVerticalForm, VerticalFormProvider, }
